// extracted by mini-css-extract-plugin
export default {"noc-banks-chart--table":"style_noc-banks-chart--table__tZIIq"};